import {
  GET_RECONCILIATION_ASSETS_BY_VOUCHER_SUCCESS,
  PROCESS_RECONCILIATION_ASSETS_SUCCESS,
  PROCESS_RECONCILIATION_PV_ASSETS_SUCCESS,
  SAVE_RECONCILIATION_ASSETS_SUCCESS,
  SAVE_RECONCILIATION_PV_ASSETS_SUCCESS,
  SAVE_RECONCILIATION_ASSET_ASSETS_SUCCESS,
  PROCESS_RECONCILIATION_ASSET_ASSETS_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  reconciliationAssets: [],
  reconciliationSavedAstAssets: [],
  reconciliationSavedPvAssets: [],
  reconciliationSavedAssetAssets: [],
  reconciliationProcessedAstAssets: [],
  reconciliationProcessedPvAssets: [],
  reconciliationProcessedAssetAssets: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_RECONCILIATION_ASSETS_BY_VOUCHER_SUCCESS: {
      return {
        ...state,
        reconciliationAssets: action.data
      };
    }

    case SAVE_RECONCILIATION_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationSavedAstAssets: action.data
      }
    }

    case SAVE_RECONCILIATION_PV_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationSavedPvAssets: action.data
      }
    }

    case PROCESS_RECONCILIATION_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationProcessedAstAssets: action.data
      }
    }

    case PROCESS_RECONCILIATION_PV_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationProcessedPvAssets: action.data
      }
    }

    case SAVE_RECONCILIATION_ASSET_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationSavedAssetAssets: action.data
      }
    }

    case PROCESS_RECONCILIATION_ASSET_ASSETS_SUCCESS: {
      return {
        ...state,
        reconciliationProcessedAssetAssets: action.data
      }
    }


    default:
      return state;
  }
}
